import React, { useState } from 'react';
import { NoAlerts } from '../NoAlerts';
import { makeStyles } from '@material-ui/styles';
import { AlertBarChartForm } from './AlertBarChartForm';
import { WidgetFooter } from '../../WidgetFooter';
import { useTranslation } from 'react-i18next';
import { ModalActionButton, useModal } from '@topconagriculture/modal';
import { Button, ButtonVariants } from '@topconagriculture/react-components';
import { AlertBarChart } from './AlertBarChart';
import { Form, useForm } from 'react-final-form';
import { useAlertsMutation } from '../hooks/useAlertsMutation';
import { AlertBarChartLegend } from './AlertBarChartLegend';
import { Loader } from '@topconagriculture/loader';
import { useDeviationAlertsSubscription } from '../hooks/useDeviationAlertsSubscription';
const useStyles = (isModal) => makeStyles(() => ({
    container: { width: '100%', overflow: 'auto hidden', height: isModal ? 215 : 250 },
    checkboxContainer: { position: 'relative' },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        '&:first-child': {
            height: 34,
        },
        '& button': { maxWidth: 150 },
        '& span': {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    narrowButton: {
        minWidth: 80,
        width: 'fit-content',
        minHeight: 20,
        paddingTop: 3,
        paddingBottom: 3,
    },
}));
const FooterButtons = ({ widgetType, data }) => {
    var _a;
    const classes = useStyles()();
    const { t } = useTranslation();
    const form = useForm();
    const disabled = form.getState().invalid;
    return (data === null || data === void 0 ? void 0 : data.length) ? (React.createElement("div", { className: classes.buttonWrapper },
        React.createElement(ModalActionButton, { action: (_a = form === null || form === void 0 ? void 0 : form.mutators) === null || _a === void 0 ? void 0 : _a.selectAll, btnLabel: t('common:select_all'), title: t('common:select_all').toUpperCase() }),
        React.createElement(Button, { className: classes.narrowButton, role: ButtonVariants.primary, disabled: disabled, label: t('widget:clear_alerts'), type: "submit", form: widgetType, title: t('widget:clear_alerts').toUpperCase() }))) : null;
};
export const DeviationWidgetL = (props) => {
    const { modalParams } = useModal();
    const link = (props === null || props === void 0 ? void 0 : props.link) || (modalParams === null || modalParams === void 0 ? void 0 : modalParams.link);
    const widget = (props === null || props === void 0 ? void 0 : props.widget) || (modalParams === null || modalParams === void 0 ? void 0 : modalParams.widget);
    const widgetType = widget === null || widget === void 0 ? void 0 : widget.type;
    const { data, isLoading } = useDeviationAlertsSubscription(widgetType);
    const { mutate: removeAlerts } = useAlertsMutation(widgetType);
    const classes = useStyles(!!modalParams)();
    const [items, setItems] = useState([]);
    const onSubmit = (values) => {
        const ingredientIds = Object.entries(values)
            .filter(([, value]) => value)
            .map(([key]) => key);
        removeAlerts(ingredientIds);
    };
    const validate = (values) => {
        if (Object.values(values).every((value) => !value)) {
            return { invalid: true };
        }
        return {};
    };
    return (React.createElement(Form, { onSubmit: onSubmit, validate: validate, mutators: {
            selectAll: (_args, state, utils) => {
                Object.values(state.fields).forEach((field) => {
                    utils.changeValue(state, field.name, () => true);
                });
            },
        }, render: ({ handleSubmit }) => (React.createElement(React.Fragment, null,
            isLoading ? (React.createElement(Loader, null)) : (data === null || data === void 0 ? void 0 : data.length) ? (React.createElement(React.Fragment, null,
                React.createElement(AlertBarChartLegend, null),
                React.createElement("div", { className: classes.container },
                    React.createElement(AlertBarChart, { setItems: setItems, data: data, link: link, widget: widget }),
                    React.createElement("div", { className: classes.checkboxContainer },
                        React.createElement(AlertBarChartForm, { items: items, handleSubmit: handleSubmit, widgetType: widgetType }))))) : (React.createElement(NoAlerts, { widgetType: widgetType })),
            React.createElement(WidgetFooter, { link: link, viewMoreButtonIsDisabled: false, center: React.createElement(FooterButtons, { widgetType: widgetType, data: data }) }))) }));
};
//# sourceMappingURL=DeviationWidgetL.js.map